/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'support';
const componentName = 'tech-support-page-card';
const prefix = `${moduleName}.${componentName}`;

export const inProgressLabel = `${prefix}.inProgressLabel`;
export const nothingInProgressLabel = `${prefix}.nothingInProgressLabel`;
export const runningPreChecksLabel = `${prefix}.runningPreChecksLabel`;
export const viewProgressLabel = `${prefix}.viewProgressLabel`;
export const preparingPackageLabel = `${prefix}.preparingPackageLabel`;

export const ENGLISH = {
    [inProgressLabel]: 'In Progress',
    [nothingInProgressLabel]: 'Nothing currently in progress',
    [runningPreChecksLabel]: 'Running Prechecks',
    [viewProgressLabel]: 'View Progress',
    [preparingPackageLabel]: 'Preparing Package',
};
